import { useAnalytics } from '@townsquare/analytics';
import { getModifiedShortcut, useKeyboardShortcut } from '@townsquare/keyboard-shortcuts';
import {
	GO_FOR_YOU_SHORTCUT,
	GO_PROJECTS_PAGE_SHORTCUT,
	GO_GOALS_PAGE_SHORTCUT,
	GO_TEAMS_PAGE_SHORTCUT,
	GO_TAGS_PAGE_SHORTCUT,
} from '@townsquare/keyboard-shortcuts/constants';
import { useKeyboardShortcutStore } from '@townsquare/keyboard-shortcuts/store';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { goalDirectoryRoute } from '@townsquare/routes/goal-directory-view';
import { homeTabRoute } from '@townsquare/routes/hometab-view';
import { projectDirectoryRoute } from '@townsquare/routes/project-directory-view';
import { staffDirectoryRoute } from '@townsquare/routes/staff-directory-view';
import { tagsDirectoryRoute } from '@townsquare/routes/tags-directory';
import { useOpenInNewTab } from '@townsquare/ui-interactions';

export const useKeyboardShortcuts = () => {
	const analytics = useAnalytics();
	const { pushTo } = useRouterActions();
	const [{ type }] = useKeyboardShortcutStore();
	const openInNewTab = useOpenInNewTab();

	const handleGoToKeypress = (_e: KeyboardEvent, keypress: string | undefined) => {
		switch (keypress) {
			case getModifiedShortcut(type, GO_FOR_YOU_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goHomePageShortcut');
				void pushTo(homeTabRoute);
				break;
			case getModifiedShortcut(type, GO_PROJECTS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goProjectsPageShortcut');
				void pushTo(projectDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_GOALS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goGoalsPageShortcut');
				void openInNewTab(goalDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_TEAMS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goTeamsPageShortcut');
				void openInNewTab(staffDirectoryRoute);
				break;
			case getModifiedShortcut(type, GO_TAGS_PAGE_SHORTCUT):
				void analytics.ui('keyboardShortcut', 'pressed', { shortcutType: type }, 'goTagsPageShortcut');
				void pushTo(tagsDirectoryRoute);
				break;
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_FOR_YOU_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_PROJECTS_PAGE_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_GOALS_PAGE_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_TEAMS_PAGE_SHORTCUT, handleGoToKeypress);
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useKeyboardShortcut(GO_TAGS_PAGE_SHORTCUT, handleGoToKeypress);
};
